<template>
  <div class="guarantee">
    <p class="mb20 bold">我的担保</p>
    <div class="main">
      <div class="top">
        <p class="mb10">剩余担保额度</p>
        <p class="fz30">￥{{guarantee_detail.guarantee_price}}</p>
        <div class="fr ac mt20">
          <div class="mr20">
            <p
              class="fz20 mb10"
            >￥{{sub(guarantee_detail.guarantee_total_price,guarantee_detail.guarantee_price)}}</p>
            <p class>已用担保额度</p>
          </div>
          <div class="vertical"></div>
          <div class="ml20">
            <p class="fz20 mb10">￥{{guarantee_detail.guarantee_total_price}}</p>
            <p class>我的担保额度</p>
          </div>
        </div>
      </div>
      <p class="mt20 mb20">我的担保记录</p>
      <div class="bottom">
        <el-table :data="guarantees" style="width: 100%">
          <el-table-column
            prop="create_time"
            label="日期"
            width="180"
            align="center"
            header-align="center"
          />
          <el-table-column prop="company_name" label="用户" align="center" header-align="center" />
          <el-table-column prop="order_no" label="订单号" align="center" header-align="center">
            <template slot-scope="scope">
              <p
                style="text-decoration: underline;"
                class="blue cursor"
                @click="go(`/orderdetail?id=${scope.row.order_id}&type=guar`)"
              >{{scope.row.order_no}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="guarantee_price" label="担保金额" align="center" header-align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.guarantee_type == '0'" class="red">-￥{{scope.row.guarantee_price}}</p>
              <p v-else class="green">+￥{{scope.row.guarantee_price}}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="fr ac jc">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="page"
          class="mt20 mb20"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      guarantee_detail: {},
      total: 0,
      page: 1,
      guarantees: []
    };
  },
  created() {
    this.getMemberGuaranteeDetail();
    this.getMemberGuarantees();
  },
  watch: {
    page(n) {
      this.getMemberGuarantees();
    }
  },
  methods: {
    getMemberGuaranteeDetail() {
      this.post("platformSaleInterfaces/v1.0/getSaleDetail").then(res => {
        this.guarantee_detail = res.data;
      });
    },
    getMemberGuarantees() {
      this.post("memberInterfaces/v1.0/getMemberGuarantees", {
        page: this.page
      }).then(res => {
        this.guarantees = res.data;
        this.total = res.total;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.guarantee {
  font-size: 14px;
  .main {
    .top {
      background-color: #458ef6;
      padding: 20px 0;
      padding-left: 50px;
      color: white;
      .vertical {
        width: 1px;
        height: 2em;
        background-color: #fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/guarantee/index.vue